import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Button,
  FormFieldInputNew,
  Notification,
  ThreeDotLoader,
} from "@netapp/bxp-design-system-react";
import { useTranslation } from "react-i18next";
import "./Subscribe.scss";

const OtpModal = ({
  email,
  advisoryId,
  onClose,
  notification,
  setNotification
}) => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);

  // Autofocus the OTP input for better mobile UX
  useEffect(() => {
    const t = setTimeout(() => {
      inputRef.current?.focus();
    }, 150);
    return () => clearTimeout(t);
  }, []);

  const confirmOtp = async () => {
    const trimmedOtp = String(otp || "").trim();
    if (!trimmedOtp) return;

    const url = `${process.env.REACT_APP_API_BASE_URL}/otp_sub`;
    const body = {
      adv_id: advisoryId,
      subscriber: email,
      otp: trimmedOtp
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("OTP confirmation successful:", data);

      setNotification({
        visible: true,
        message: t("modal_subscriptionConfirmed.other"),
        type: "success"
      });

      setTimeout(() => {
        setNotification({ visible: false, message: "", type: "success" });
        onClose();
      }, 4000);
    } catch (error) {
      console.error("OTP confirmation failed:", error);
      setNotification({
        visible: true,
        message: t("modal_otpConfirmationFailed.other"),
        type: "error"
      });
      setTimeout(() => {
        setNotification({ visible: false, message: "", type: "error" });
      }, 4000);
    } finally {
      setIsLoading(false);
    }
  };

  // Submit on Enter key
  const onKeyDown = (e) => {
    if (e.key === "Enter" && !isLoading && otp) {
      setIsLoading(true);
      confirmOtp();
    }
  };

  const headerTitle =
    advisoryId === "ntap_all"
      ? t("advisory_subscribeAllUpdates.other")
      : t("advisory_subscribeToAdvisory.other", { id: advisoryId });

  return (
    <Modal className="subscribe-modal">
      <ModalHeader className="modal-header">
        {headerTitle}
      </ModalHeader>

      {/* Make content scrollable on small screens by using the same class */}
      <ModalContent className="modal-content">
        {notification.visible && (
          <Notification type={notification.type}>
            {notification.message}
          </Notification>
        )}

        <FormFieldInputNew
          ref={inputRef}
          className="form-field-input-new"
          label={t("modal_otpForEmail.other", { email })}
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={t("modal_enterOtp.other")}
        />
      </ModalContent>

      {/* Stack buttons full-width on mobile using the same footer class */}
      <ModalFooter className="subscribe-modal-footer">
        <Button color="secondary" onClick={onClose} disabled={isLoading}>
          {t("modal_cancel.other")}
        </Button>

        <Button
          onClick={() => {
            setIsLoading(true);
            confirmOtp();
          }}
          disabled={!otp || isLoading}
        >
          {isLoading ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <ThreeDotLoader />
              <span style={{ marginLeft: 8 }}>{t("modal_confirm.other")}</span>
            </div>
          ) : (
            t("modal_confirm.other")
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OtpModal;